//todo refactor w TypeScript

export const state = () => ({
  user: {
    id: 0,
    auth_key: '',
    application_id: '',
    email: '',
    email_confirmed: '',
    is_email_subscriber: false,
    confirmation_level_id:'',
    phone: '',
    web_push_enabled: false,
    web_push_token:null,
    web_push_token_type:null,
    mobile_push_token:null,
  }
})

export const getters = {
  /**
   * @deprecated use getter user instead
   */
  getUser: (state) => {
    return state.user
  },
  user: (state) => {
    return state.user
  },
  userHasEmail: (state, getters) => !!getters.user.email,
  userEmailConfirmed: (state, getters) => getters.user.email_confirmed,
  // возможно ненужное поле
  userIsEmailSubscriber: (state, getters) => !!getters.user.is_email_subscriber,
  userHasPhone: (state, getters) => !!getters.user.phone,
  userClientSupportsWebPush: () => window.$nuxt.$webPush.allowed(),
  userHasWebPush: (state, getters) => getters.user.web_push_enabled,
  userAllContactsFilled: (state, getters) => (
    getters.userHasEmail && getters.userHasPhone && (!getters.userClientSupportsWebPush || getters.userHasWebPush)
  )
}

export const mutations = {
  setUser(state, user) {
    state.user = Object.assign(state.user, user)
  }
}

export const actions = {
  getUser({state, commit}) {
    if (state.user.id === 0 || !state.user.id) {
      return this.$api.get('user').then((response) => {
        commit('setUser', response.data)
      })
    }
  },
  async updateUser({commit}, user) {
    try {
      const {data} = await this.$api.patch(`user`, user)
      commit('setUser', data)
    } catch (err) {

    }
  },

  reloadUser({commit}) {
    return this.$api.get('user').then((response) => {
      commit('setUser', response.data)
    })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
